module.exports = __webpack_public_path__ + "img/poisson.587b693d.svg";